import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-778a910b")

_pushScopeId("data-v-778a910b")
const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = { class: "kn-page-content p-grid p-m-0" }
const _hoisted_3 = { class: "kn-list--column p-col-4 p-sm-4 p-md-3 p-p-0" }
const _hoisted_4 = { class: "kn-list-item-text" }
const _hoisted_5 = { class: "p-d-flex p-flex-row kn-truncated" }
const _hoisted_6 = { class: "p-col-8 p-sm-8 p-md-9 p-p-0 p-m-0" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FabButton = _resolveComponent("FabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Chip = _resolveComponent("Chip")
  const _component_Button = _resolveComponent("Button")
  const _component_Menu = _resolveComponent("Menu")
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_router_view = _resolveComponent("router-view")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
          start: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('kpi.kpiScheduler.title')), 1)
          ]),
          end: _withId(() => [
            _createVNode(_component_FabButton, {
              icon: "fas fa-plus",
              onClick: _ctx.showForm,
              "data-test": "new-button"
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 0,
              mode: "indeterminate",
              class: "kn-progress-bar",
              "data-test": "progress-bar"
            }))
          : _createCommentVNode("", true),
        (!_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Listbox, {
              key: 1,
              class: "kn-list",
              options: _ctx.schedulerList,
              listStyle: _ctx.kpiSchedulerDescriptor.listBox.style,
              filter: true,
              filterPlaceholder: _ctx.$t('common.search'),
              filterMatchMode: "contains",
              filterFields: _ctx.kpiSchedulerDescriptor.filterFields,
              emptyFilterMessage: _ctx.$t('common.info.noDataFound'),
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showForm($event.value))),
              "data-test": "scheduler-list"
            }, {
              empty: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
              ]),
              option: _withId((slotProps) => [
                _createVNode("div", {
                  class: ["kn-list-item", _ctx.getBordersClass(slotProps.option.jobStatus)],
                  "data-test": "list-item"
                }, [
                  _createVNode("div", _hoisted_4, [
                    _createVNode("div", null, [
                      _createVNode("span", null, _toDisplayString(slotProps.option.name), 1)
                    ]),
                    _createVNode("div", _hoisted_5, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(slotProps.option.kpiNames.split(','), (kpiName, index) => {
                        return _withDirectives((_openBlock(), _createBlock(_component_Chip, {
                          class: "p-m-1",
                          key: index,
                          label: kpiName
                        }, null, 8, ["label"])), [
                          [
                            _directive_tooltip,
                            slotProps.option.kpiNames,
                            void 0,
                            { top: true }
                          ]
                        ])
                      }), 128))
                    ])
                  ]),
                  (slotProps.option.jobStatus.toUpperCase() !== 'EXPIRED')
                    ? (_openBlock(), _createBlock("i", {
                        key: 0,
                        class: _ctx.playIcon(slotProps.option.jobStatus),
                        onClick: ($event: any) => (_ctx.startSchedule(slotProps.option))
                      }, null, 10, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_Button, {
                    class: "p-button-link p-button-sm",
                    icon: "fa fa-ellipsis-v",
                    onClick: ($event: any) => (_ctx.toggle($event, slotProps.option)),
                    "aria-haspopup": "true",
                    "aria-controls": "overlay_menu",
                    "data-test": "menu-button"
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_Menu, {
                    ref: "menu",
                    model: _ctx.items,
                    popup: true,
                    "data-test": "menu"
                  }, null, 8, ["model"])
                ], 2)
              ]),
              _: 1
            }, 8, ["options", "listStyle", "filterPlaceholder", "filterFields", "emptyFilterMessage"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_router_view, {
          onTouched: _cache[2] || (_cache[2] = ($event: any) => (_ctx.touched = true)),
          onClosed: _cache[3] || (_cache[3] = ($event: any) => (_ctx.touched = false)),
          onInserted: _ctx.loadPage
        }, null, 8, ["onInserted"])
      ])
    ])
  ]))
})